const translations: Record<string, string> = {
  "ak_fc_rain": "Rain",
  "ak_fc_drizzle": "Drizzle",
  "ak_fc_clear": "Clear",
  "ak_fc_partly_cloudy": "Partly cloudy",
  "ak_fc_cloudy": "Cloudy",
  "ak_fc_overcast": "Overcast",
  "ak_fc_current_weather_open_meteo": "Current weather (Open-Meteo) · {{sky}}",
  "ak_fc_m_s": "m/s",
  "ak_fc_sunrise": "Sunrise {{t}}",
  "ak_fc_sunset": "Sunset {{t}}",
  "ak_fc_online": "Online",
  "ak_fc_kw": "kW",
  "ak_fc_kwh": "kWh",
  "ak_fc_radiation_min_corrected": "Radiation (min-corrected)",
  "ak_fc_cloud_cover": "Cloud cover",
  "ak_fc_mw": "MW",
  "ak_fc_generated_today": "Generated today",
  "ak_fc_mwh": "MWh",
  "ak_fc_hide_series_on_chart": "Hide series on chart",
  "ak_fc_show_series_on_chart": "Show series on chart",
  "ak_fc_kwh_2": "kWh",
  "ak_fc_per_day": "per day",
  "ak_fc_base_forecast": "Base forecast",
  "ak_fc_ecmwf_forecast": "ECMWF forecast",
  "ak_fc_accumulated_since_the_start_of_the_day": "Accumulated since the start of the day as of {{hh}}:{{mm}} (station time); the current hour is counted pro rata to elapsed time",
  "ak_fc_deviation_from_the_d_2_forecast_snapsh": "Deviation from the D-2 forecast (snapshot {{at}})",
  "ak_fc_current_weather": "Current weather · {{sky}}",
};

export default translations;
